module.exports = __webpack_public_path__ + "media/application/images/svgs/info-654fb58bbdc7cdddd9daf8d2ac55a2cf.svg";